import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Form,
  Card,
  Button,
  Container,
  InputGroup,
} from "@themesberg/react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import { Routes } from "../../routes";
import swal from "sweetalert";
import { postForgotPassword } from "../../Service/AllLoginAPI";

export default () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false); // State to manage loading
  const history = useHistory();

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    const loginStatus = sessionStorage.getItem("loginStatus");
    const hasToken = !!token && token !== "null" && token !== "undefined" && token !== "";
    const isLoggedStatus = loginStatus === "true" || loginStatus === true;
    if (hasToken || isLoggedStatus) {
      history.replace("/");
    }
  }, [history]);

  const submitRecoverpassword = async (e) => {
    try {
      e.preventDefault();
      if (email !== "") {
        setLoading(true); // Set loading state to true while request is being made
        await postForgotPassword(email)
          .then((result) => {
            console.log("Forgot Password Result", result);
            swal(
              "Great",
              "Reset password link is sent to your email successfully",
              "success"
            );
            history.push(`${Routes.Signin.path}`);
          })
          .catch((error) => {
            console.log("Forgot Password Error", error);
            swal("Failed", "Failed to send reset password link", "error");
          })
          .finally(() => setLoading(false)); // Set loading state back to false
      } else {
        swal("Failed", "Please enter email", "error");
      }
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
      setLoading(false); // Set loading state back to false in case of error
    }
  };

  return (
    <main className="bg-dark vh-100">
      <section className="vh-lg-100 mt-4 mt-lg-0 bg-soft d-flex align-items-center">
        <Container>
          <Row className="justify-content-center">
            <p className="text-center">
              <Card.Link
                as={Link}
                to={Routes.Signin.path}
                className="text-gray-700"
              >
                <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> Back to
                sign in
              </Card.Link>
            </p>
            <Col
              xs={12}
              className="d-flex align-items-center justify-content-center"
            >
              <div className="signin-inner my-3 my-lg-0 bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <h3>FORGOT YOUR PASSWORD?</h3>
                <p className="mb-4">
                  Don't fret! Just type in your email and we will send you a
                  code to reset your password!
                </p>
                <Form>
                  <div className="mb-4">
                    <Form.Label htmlFor="email">Your Email</Form.Label>
                    <InputGroup id="email">
                      <Form.Control
                        required
                        autoFocus
                        type="email"
                        placeholder="Please Enter Your Email"
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </InputGroup>
                  </div>
                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100"
                    onClick={submitRecoverpassword}
                    disabled={loading} // Disable the button when loading is true
                  >
                    {loading ? "Please Wait ..." : "Recover Password"} {/* Change button text when loading */}
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};

